/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { DidDetail } from './DidDetail';
import {
  DidDetailFromJSON,
  DidDetailFromJSONTyped,
  DidDetailToJSON,
} from './DidDetail';

/**
 *
 * @export
 * @interface CallCenter
 */
export interface CallCenter {
  /**
   *
   * @type {string}
   * @memberof CallCenter
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CallCenter
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof CallCenter
   */
  shortKey?: string;
  /**
   *
   * @type {string}
   * @memberof CallCenter
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof CallCenter
   */
  groupId?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof CallCenter
   */
  dids?: Array<string>;
  /**
   *
   * @type {Array<DidDetail>}
   * @memberof CallCenter
   */
  didsDetails?: Array<DidDetail>;
  /**
   *
   * @type {string}
   * @memberof CallCenter
   */
  state?: string;
  /**
   *
   * @type {number}
   * @memberof CallCenter
   */
  officeId?: number;
}

/**
 * Check if a given object implements the CallCenter interface.
 */
export function instanceOfCallCenter(value: object): value is CallCenter {
  return true;
}

export function CallCenterFromJSON(json: any): CallCenter {
  return CallCenterFromJSONTyped(json, false);
}

export function CallCenterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CallCenter {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    key: json['key'] == null ? undefined : json['key'],
    shortKey: json['short_key'] == null ? undefined : json['short_key'],
    name: json['name'] == null ? undefined : json['name'],
    groupId: json['group_id'] == null ? undefined : json['group_id'],
    dids: json['dids'] == null ? undefined : json['dids'],
    didsDetails:
      json['dids_details'] == null
        ? undefined
        : (json['dids_details'] as Array<any>).map(DidDetailFromJSON),
    state: json['state'] == null ? undefined : json['state'],
    officeId: json['office_id'] == null ? undefined : json['office_id'],
  };
}

export function CallCenterToJSON(value?: CallCenter | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    key: value['key'],
    short_key: value['shortKey'],
    name: value['name'],
    group_id: value['groupId'],
    dids: value['dids'],
    dids_details:
      value['didsDetails'] == null
        ? undefined
        : (value['didsDetails'] as Array<any>).map(DidDetailToJSON),
    state: value['state'],
    office_id: value['officeId'],
  };
}
